import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { CookieHelper } from '../../../shared/cookie-helper';
import { AppConfig } from '../../models/appConfig.model';
import { AppconfigService } from './appconfig.service';
import { LocalService } from './local.service';

@Injectable({ providedIn: 'root' })
export class SessionService {
    private encryptedUser: string = '';
    private myHomeUrl: string = '';
    private pollInterval: any;

    constructor(
        private ngZone: NgZone,
        private _localService: LocalService,
        private _appConfigService: AppconfigService,
        private router: Router
    ) {
        this.getAppHomeConfig();
        this.listenStorageEvents();  // 🔑 instant multi-tab sync (same domain)
        this.startCookiePolling();   // 🔑 subdomain sync
    }

    private async getAppHomeConfig() {
        try {
            const result: AppConfig = await this._localService.getDefaultHome(this.encryptedUser);
            if (result) {
                this.myHomeUrl = result.homeURL;
            }
        } catch (err) {
            console.error('Error loading home config', err);
        }
    }

    async startSession(token: string) {
        // store login state in both cookie + localStorage
        localStorage.setItem("token", token);
        CookieHelper.setCookie('token_univ', token, 8); // cookie shared across subdomains
        CookieHelper.setCookie('isLoggedIn', 'true', 8); // cookie shared across subdomains
    }

    logout() {
        // clear both storage + cookie
        localStorage.removeItem("token");
        CookieHelper.eraseCookie('isLoggedIn');
        CookieHelper.eraseCookie('token_univ');
        // notify other tabs instantly
        localStorage.setItem("logout-event", Date.now().toString());

        // redirect current tab
        this.router.navigate(['/login']);
    }

    markLoggedIn() {
        CookieHelper.setCookie('isLoggedIn', 'true');
    }

    private listenStorageEvents() {
        const excludedPaths = ['engage-cal', 'vc', 'engage-unsub', 'handle-reply', 'wcmPost', 'referral', 'update-info', 'eml-pref-confirm', 'engage-unsubscribe', 'update', 'engage-sign-up', 'engagepost-webform', 'authorize', 'signup'];
        // fires in all other tabs of same browser+domain
        window.addEventListener('storage', (event) => {
            if (event.key === 'logout-event') {
                const shouldRedirect = !excludedPaths.some(path => this.router.url.includes(path));
                if (shouldRedirect)
                    this.ngZone.run(() => this.router.navigate(['/login']));
            }
        });
    }

    private startCookiePolling() {
        const excludedPaths = ['engage-cal', 'vc', 'engage-unsub', 'handle-reply', 'wcmPost', 'referral', 'update-info', 'eml-pref-confirm', 'engage-unsubscribe', 'update', 'engage-sign-up', 'engagepost-webform', 'authorize', 'signup'];
        // every 1 second, check if cookie still exists (works across subdomains)
        this.pollInterval = setInterval(() => {
            if (!this.isLoggedIn()) {
                const shouldRedirect = !excludedPaths.some(path => this.router.url.includes(path));
                if (shouldRedirect)
                    this.ngZone.run(() => this.router.navigate(['/login']));

            }
        }, 1000);
    }

    isLoggedIn(): boolean {
        return CookieHelper.getCookie('isLoggedIn') === 'true';
    }
}
